export function getYouTubeIdFromUrl(url) {
    if (!url) return null;
    const em = url.match(/youtube\.com\/embed\/([^?&#/]+)/i);
    if (em && em[1]) return em[1];
    const wm = url.match(/[?&#]v=([^?&#/]+)/i);
    if (wm && wm[1]) return wm[1];
    return null;
}

export function updateYTPlaceholders(root = document) {
    const hasMarketing = !!(window.Cookiebot && Cookiebot.consent && Cookiebot.consent.marketing);
    root.querySelectorAll('.youtubecontent').forEach(wrap => {
        const iframe = wrap.querySelector('iframe.video-embed-item');
        const msg    = wrap.querySelector('.yt-consent-message');
        if (!iframe || !msg) return;

        if (hasMarketing) {
            if (!iframe.src && iframe.dataset.cookieblockSrc) {
                iframe.src = iframe.dataset.cookieblockSrc;
            }
            iframe.style.display = '';
            msg.style.display = 'none';
        } else {
            iframe.style.display = 'none';
            msg.style.display = '';
        }
    });
}

export function installClickBlockerForYT() {
    document.addEventListener('click', function(e) {
        if (!(window.Cookiebot && Cookiebot.consent && Cookiebot.consent.marketing)) {
            const inYT = e.target.closest('.youtubecontent');
            if (!inYT) return;
            if (e.target.closest('.yt-consent-message')) {
                e.stopPropagation();
                return;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
        }
    }, true);
}
